export const actionTypes = {
    GET_ALL_AUDITS: "GET_ALL_AUDITS",
    GET_ALL_AUDITS_SUCCESS: "GET_ALL_AUDITS_SUCCESS",
    GET_ALL_AUDITS_FAILURE: "GET_ALL_AUDITS_FAILURE",
    AUDIT_RESET_STATE: "AUDIT_RESET_STATE"
};

export const getAllAuditsAction = (payload: any) => ({
    type: actionTypes.GET_ALL_AUDITS,
    payload,
});

export const getAllRecoveryPointUsersSuccessAction = (payload: any) => ({
    type: actionTypes.GET_ALL_AUDITS_SUCCESS,
    payload,
});

export const getAllRecoveryPointUsersFailureAction = (error: any) => ({
    type: actionTypes.GET_ALL_AUDITS_FAILURE,
    error,
});

export const resetState = () => ({
    type: actionTypes.AUDIT_RESET_STATE,
});
